"use client";
import Link from "next/link.js";
import { usePathname } from "next/navigation";
import menu_data, { admin_menu_data } from "../../../data/MenuData";
import { useSession } from "@/component/SessionProvider";
import { auth_menu_data } from "@/data/menuData.authenticated";

export const SHOW_HOMEPAGE_MENUS = true;

const NavMenuTwo = () => {
  const currentRoute = usePathname();
  const { session } = useSession();

  const isMenuItemActive = (menuLink: string) => {
    return currentRoute === menuLink;
  };

  const isSubMenuItemActive = (subMenuLink: string) => {
    return currentRoute === subMenuLink;
  };

  const route = usePathname();
  const isHome = route === "/";
  const isAdminRoute = route?.includes("/admin");

  const menu = session.isAuthenticated ? auth_menu_data : menu_data;

  const getMenu = () => {
    if (isAdminRoute) return admin_menu_data;
    if (isHome && SHOW_HOMEPAGE_MENUS) return menu_data;

    return menu;
  };

  return (
    <ul className="navigation">
      {getMenu()
        .filter((items) => items.page === "nav_2")
        .map((menu) => (
          <li
            key={menu.id}
            className={menu.has_dropdown ? "menu-item-has-children" : ""}
          >
            <Link
              href={menu.link}
              className={`section-link ${
                isMenuItemActive(menu.link) ||
                (menu.sub_menus &&
                  menu.sub_menus.some(
                    (sub_m) => sub_m.link && isSubMenuItemActive(sub_m.link)
                  ))
                  ? "active"
                  : ""
              }`}
            >
              {menu.title}
            </Link>

            {menu.has_dropdown && (
              <>
                {menu.sub_menus && (
                  <ul className="sub-menu">
                    {menu.sub_menus.map((sub_m, i) => (
                      <li key={i}>
                        <Link
                          href={sub_m.link}
                          className={
                            sub_m.link && isSubMenuItemActive(sub_m.link)
                              ? "active"
                              : ""
                          }
                        >
                          {sub_m.title}
                          {sub_m.commingSoon && (
                            <span style={{ fontSize: "5px" }}>
                              {" "}
                              Comming Soon
                            </span>
                          )}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            )}
          </li>
        ))}
    </ul>
  );
};

export default NavMenuTwo;
